import { Component, OnInit } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { FacetingService } from "../../../services/faceting.service"
import { EduComponent } from "../../../utils/eduComponent"
import { AddOnViewService } from "../../../services/add-on-view.service"
import {
    ADD_ON_ALLOWED_MEDIA_TYPES,
    ORDERED_MEDIA_TYPES,
    STUDENT_ORDERED_MEDIA_TYPES,
} from "../../../models/constants"
import Utils from "../../../utils/utils"
import { fadeInXY } from "../../../utils/animations"

@Component({
    selector: "app-filter-by-type",
    templateUrl: "./filter-by-type.component.html",
    styleUrls: ["./filter-by-type.component.scss"],
    animations: [fadeInXY],
    standalone: false,
})
export class FilterByTypeComponent extends EduComponent implements OnInit {
    mediaTypes: string[] = []
    selectedType: string = null

    constructor(
        private route: ActivatedRoute,
        private facetingService: FacetingService,
        private addOnService: AddOnViewService
    ) {
        super()
    }

    public ngOnInit() {
        if (Utils.hasStudentExperience()) {
            this.mediaTypes = STUDENT_ORDERED_MEDIA_TYPES
        } else if (this.addOnService.isAddonView) {
            this.mediaTypes = ADD_ON_ALLOWED_MEDIA_TYPES
        } else {
            this.mediaTypes = ORDERED_MEDIA_TYPES
        }

        this.addSub(
            this.route.queryParams.subscribe(() => {
                const facets: string[] = this.facetingService.getSelectedFacets(this.route)
                this.selectedType = null
                facets.map((facet: string) => {
                    if (facet.indexOf("media_type") !== -1) {
                        this.selectedType = facet.split(":")[1]
                    }
                })
            })
        )
    }

    public changeType($event, type: string) {
        this.facetingService.addFilter(`media_type:${type}`, this.route, true)
    }
}
